export enum ExpenseType {
  Recurring,
  OneTime,
  Labor,
  Supplies,
}
